import AboutSection from '../../sections/AboutSection';
// import BitacoraSection removed; using ModernBitacoraSection
import FasesSection from '../../sections/FasesSection';
import Gallery from '../../sections/Gallery';
import Descargas from '../../components/Descargas';
import Hero from '../../components/Hero';

import ModernBanner from '../../components/ModernBanner';


import { motion, AnimatePresence } from "framer-motion";
import { FaFilePdf, FaProjectDiagram, FaLightbulb, FaClipboardList, FaMap } from "react-icons/fa";

import './PaisajeAgavero.css';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  Home as HomeIcon,
  MapPin as MapPinIcon,
  FileText as FileTextIcon,
  Phone as PhoneIcon,
  ChevronDown,
  ChevronRight,
  Menu,
  X,
  ExternalLink,
  Subtitles,
  Users,
  Map,
  Landmark,
  Calendar,
  MapPin,
  Info,
  Waves,
  TreePine,
  MountainSnow,
  TreePineIcon,
  MountainSnowIcon,MapIcon,ClipboardListIcon,LightbulbIcon,CompassIcon,FileText,FileSignature,FileSpreadsheet,Zap,BarChart3,
  LayersIcon,GlobeIcon,InfoIcon,TargetIcon,Target
} from 'lucide-react';


const FullWidthVisorWithSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('uga');

  return (
    <section id="visor-completo" className="py-16">
      <div className="max-w-[2000px] mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Plataforma Geoespacial Completa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Sistema de información geográfica integrado con documentación técnica completa
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar - Ancho fijo */}
          <motion.div
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            className={`lg:w-96 ${sidebarOpen ? 'block' : 'hidden lg:block'}`}
          >
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-xl border border-gray-100 dark:border-gray-700 sticky top-6">
              {/* Botón toggle para móviles */}
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden mb-4 w-full p-2 bg-gradient-to-r from-blue-500 to-teal-500 
                  text-white rounded-lg flex items-center justify-center gap-2"
              >
                {sidebarOpen ? 'Ocultar Panel' : 'Mostrar Panel'}
                <ChevronRight className={`w-4 h-4 transition-transform ${sidebarOpen ? 'rotate-90' : ''}`} />
              </button>

              {/* Tabs de navegación */}
              <div className="flex mb-6 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
                <button
                  onClick={() => setActiveTab('uga')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'uga'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Clasificación UGA
                </button>
                <button
                  onClick={() => setActiveTab('descripcion')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'descripcion'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Descripción UGA
                </button>
                <button
                  onClick={() => setActiveTab('politica')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'politica'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Política Ambiental
                </button>
              </div>

              {/* Contenido según tab activo */}
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTab}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="space-y-6"
                >
                  {activeTab === 'uga' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <LayersIcon className="w-5 h-5 text-blue-500 mr-2" />
                          Clasificación de UGAs
                        </h3>
                        <img
                          src="/images/Clave-de-UGA-agavero.PNG"
                          alt="Clasificación de Unidades de Gestión Ambiental"
                          className="w-full h-auto rounded-lg shadow-md mb-4"
                        />
                        <p className="text-sm text-gray-600 dark:text-gray-300">
                          Mapa de clasificación de las Unidades de Gestión Ambiental (UGAs) 
                          de la región Paisaje Agavero.
                        </p>
                      </div>
                    </>
                  )}

                  {activeTab === 'descripcion' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Info className="w-5 h-5 text-teal-500 mr-2" />
                          Descripción de las UGAs
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4">
                          Las <strong>Unidades de Gestión Ambiental (UGAs)</strong> son la unidad mínima 
                          del territorio a la que se asignan determinados lineamientos y estrategias 
                          ecológicas para su manejo específico.
                        </p>
                        
                        <div className="space-y-4">
                          <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 
                            rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Características</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Unidad territorial homogénea</li>
                              <li>• Criterios específicos de manejo</li>
                              <li>• Estrategias ecológicas definidas</li>
                              <li>• Monitoreo individualizado</li>
                            </ul>
                          </div>
                          
                          <div className="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 
                            rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Objetivos</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Gestión ambiental específica</li>
                              <li>• Aplicación de lineamientos</li>
                              <li>• Evaluación de resultados</li>
                              <li>• Adaptación de estrategias</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {activeTab === 'politica' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Target className="w-5 h-5 text-purple-500 mr-2" />
                          Política Ambiental
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4 text-justify">
                          El presente <strong>Modelo de Ordenamiento Ecológico y Territorial Regional</strong> considera una zonificación, integrada por políticas que buscan definir el estado deseable del territorio mediante lineamientos, estrategias y criterios para conservar y controlar el deterioro del ambiente así como el aprovechamiento sustentable de los recursos naturales.
                        </p>
                      </div>
                    </>
                  )}
                </motion.div>
              </AnimatePresence>

              {/* Botones de acción */}
              <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                <div className="grid grid-cols-1 gap-3">
                  <a
                    href="https://siga.jalisco.gob.mx/ordenamiento/visores/visorPaisajeAgavero/index.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2.5 bg-gradient-to-r from-blue-500 to-teal-500 text-white 
                      rounded-lg text-sm font-medium text-center hover:shadow-lg transition-all"
                  >
                    <ExternalLink className="w-4 h-4 inline mr-1" />
                    Abrir en Nueva Ventana
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Visor - Ocupa el resto del espacio */}
          <div className="flex-1">
            <div className="bg-gray-900 rounded-2xl overflow-hidden shadow-2xl">
              <div className="p-4 bg-gradient-to-r from-gray-800 to-gray-900 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-teal-500 rounded-lg">
                    <GlobeIcon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Visor GIS Paisaje Agavero</h3>
                    <p className="text-sm text-gray-400">Sistema interactivo de información geográfica</p>
                  </div>
                </div>
              </div>
              
              <div className="h-[600px]">
                <iframe
                  src="https://siga.jalisco.gob.mx/ordenamiento/visores/visorPaisajeAgavero/index.html"
                  className="w-full h-full border-0"
                  title="Visor GIS Paisaje Agavero"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const DetailBadge = ({ icon: Icon, label, value }) => (
  <div className="flex items-center p-3 bg-gray-50 dark:bg-gray-700 rounded-xl transition-all hover:bg-teal-100 dark:hover:bg-teal-900/30">
    <Icon className="text-teal-600 dark:text-teal-400 mr-3 flex-shrink-0" size={20} />
    <div className="text-sm">
      <span className="font-semibold text-gray-700 dark:text-gray-300 block leading-tight">{label}:</span>
      <span className="text-gray-900 dark:text-white font-bold">{value}</span>
    </div>
  </div>
);
const Items = [
  {
    title: "Archivos Vectoriales",
    description: "Archivos geoespaciales para la consulta SIG.",
    imageUrl: "images/vectoriales.png", // sky-600
    baseColor: "sky",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/VectorialesPaisajeAgavero.zip",
    target: "_blank",
  },
  {
    title: "Fichas UGAs",
    description: "Informacion detallada de cada Unidad de Gestión Ambiental (UGA).",
    imageUrl: "images/FICHAS_UGA.png", // green-600
    baseColor: "green",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Paisaje%20Agavero.pdf",
    target: "_blank",
  },
  {
    title: "Criterios",
    description: "Regulaciones ecológicas para la preservación y restauración del territorio.",
    imageUrl: "images/Criterios.png", // orange-600
    baseColor: "orange",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Criterios%20Regi%C3%B3n%20Paisaje%20Agavero.pdf",
    target: "_blank",
  },
  {
    title: "Estrategias Ecologicas",
    description: "Proyectos de orientación para la protección del entorno natural.",
    imageUrl: "images/Estrategias.png", // red-600
    baseColor: "red",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Estrategias%20Regi%C3%B3n%20Paisaje%20Agavero.pdf",
    target: "_blank",
  },
  {
    title: "Lineamientos",
    description: "Conservar, proteger y restaurar los recursos naturales de la región.",
    imageUrl: "images/Lineamientos.png", // indigo-600
    baseColor: "indigo",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Lineamientos%20ecol%C3%B3gicos%20Regi%C3%B3n%20Paisaje%20Agavero.pdf",
    target: "_blank",
  },
  
];
const items = [
  {
    title: "Archivos Vectorialess",
    description: "Archivos geoespaciales para la consulta SIG.",
     img: <img src="images/vectoriales.png" alt="Archivos Vectoriales" className="w-16 h-16 mb-4" />,
    icon: <FaMap className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/VectorialesPaisajeAgavero.zip",
    target: "_blank",
  },
  {
    title: "Fichas UGAs",
    description: " Informacion detallada de cada Unidad de Gestión Ambiental (UGA).",
    img: <img src="images/FICHAS_UGA.png" alt="Fichas" className="w-16 h-16 mb-4" />,
    icon: <FaClipboardList className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Paisaje%20Agavero.pdf",
    target: "_blank",
  },
  {
    title: "Criterios",
    description: "Regulaciones ecológicas para la preservación y restauración del territorio.",
     img: <img src="images/Criterios.png" alt="Criterios" className="w-16 h-16 mb-4" />,
    icon: <FaFilePdf className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Criterios%20Regi%C3%B3n%20Paisaje%20Agavero.pdf",
  },
  {
    title: "Estrategias Ambientales",
    description: " Proyectos de orientación para la protección del entorno natural.",
    img: <img src="images/Estrategias.png" alt="Estrategias" className="w-16 h-16 mb-4" />,
    icon: <FaProjectDiagram className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Estrategias%20Regi%C3%B3n%20Paisaje%20Agavero.pdf",
  },
  {
    title: "Lineamientos",
    description: "Conservar, proteger y restaurar los recursos naturales de la región.",
    img: <img src="images/Lineamientos.png" alt="Lineamientos" className="w-16 h-16 mb-4" />,
    icon: <FaLightbulb className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Lineamientos%20ecol%C3%B3gicos%20Regi%C3%B3n%20Paisaje%20Agavero.pdf",
  },
];

const ModernBitacoraSection = ({ items }) => {
  const [expandedSection, setExpandedSection] = useState(0);

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800" id="bitacora">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Bitácora del Programa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Registro documental completo del proceso de ordenamiento ecológico
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.button
                key={index}
                onClick={() => setExpandedSection(expandedSection === index ? null : index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`p-6 rounded-2xl transition-all duration-300 text-left ${
                  expandedSection === index
                    ? `bg-gradient-to-br ${item.color} text-white shadow-2xl`
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 shadow-lg hover:shadow-xl'
                }`}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className={`p-3 rounded-xl ${
                    expandedSection === index
                      ? 'bg-white/20'
                      : `bg-gradient-to-br ${item.color}`
                  }`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-semibold">{item.title}</h3>
                </div>
                <p className={`text-sm ${
                  expandedSection === index ? 'text-white/90' : 'text-gray-500 dark:text-gray-400'
                }`}>
                  {expandedSection === index ? 'Ver documentos ↓' : 'Ver documentos →'}
                </p>
              </motion.button>
            );
          })}
        </div>

        <AnimatePresence>
          {expandedSection !== null && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700">
                {items[expandedSection].content.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="mb-8 last:mb-0">
                    <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 flex items-center">
                      <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full mr-3" />
                      {section.subtitle}
                    </h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      {section.items.map((doc, docIndex) => (
                        <a
                          key={docIndex}
                          href={doc.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-teal-50 
                            dark:hover:from-blue-900/20 dark:hover:to-teal-900/20 transition-all duration-300"
                        >
                          <div className="flex items-center gap-3">
                            <FileText className="w-5 h-5 text-blue-500 group-hover:text-teal-500 transition-colors" />
                            <span className="text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white">
                              {doc.text}
                            </span>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
                
                <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                  <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
                    {items[expandedSection].content.reduce((total, section) => total + section.items.length, 0)} documentos disponibles
                  </p>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

const imageList = [
    {
        id: '1',
        src: 'images/Escudo_Amatitán.png',
        thumbnail: 'images/Escudo_Amatitán.png',
        alt: 'Paisaje con montañas',
        caption: 'Amatitán.'
    },
    {
        id: '2',
        src: 'images/tomatlan-escudo.png',
        thumbnail: 'images/tomatlan-escudo.png',
        alt: 'Ciudad nocturna',
        caption: 'Tomatlán.'
    },
    {
        id: '3',
        src: 'images/la_huerta-escudo.png',
        thumbnail: 'images/la_huerta-escudo.png',
        alt: 'Bosque en otoño',
        caption: 'La Huerta.'
    },
    {
        id: '4',
        src: 'images/cihuatlan-escudo.png',
        thumbnail: 'images/cihuatlan-escudo.png',
        alt: 'Playa tropical',
        caption: 'Cihuatlán.'
    },
    
];

// Datos de los municipios
const municipalities = [
  {
    id: 1,
    name: 'Amatitán',
    shield: 'images/Escudo_Amatitan.png',
    description: 'Con agricultura de riego enfocada en agave y maíz, y ganadería menor, el municipio se ubica en valles y lomeríos con suelos volcánicos fértiles y pequeños arroyos. Su entorno favorece el ecoturismo rural y la implementación de prácticas de manejo sostenible.',
    population: '21,115 habitantes',
    area: '111.8 km²',
    foundation: '1923',
    attractions: 'Colinas, bosques semicolares y arroyos rurales en El Arenal, junto con laderas de agave azul, conforman un entorno ideal para senderismo, recorridos entre campos y naturaleza. Destacan sitios como sus cascos de hacienda como Huaxtla y La Quitería, además del museo local del Paisaje Agavero. ',
    color: 'from-blue-500 to-teal-600',
    administrativeRegion: 'Región Valles',
    
    NumerodeUgas: '5',
    EcologicaZona: 'Área Natural Protegida Área Municipal de Protección Hidrológica Barranca del Río Santiago.',


  },
  {
    id: 2,
    name: 'El Arenal',
    shield: 'images/Escudo_El_Arenal.png',
    description: 'Destacado por la producción de agave azul y agricultura de riego, complementada con ganadería menor, se desarrolla en valles con suelos volcánicos y vegetación riparia. Estas condiciones permiten el turismo rural y la aplicación de técnicas de conservación.',
    population: '16,490 habitantes',
    area: '172.6 km²',
    foundation: '1837',
    attractions: 'Los campos de agave azul que cubren lomeríos y valles forman un paisaje rural emblemático ideal para caminatas y recorridos entre cultivos. La Hacienda de San José del Refugio y antiguas haciendas. Sus rutas permiten combinar senderismo interpretativo y gastronomía regional.',
    color: 'from-green-500 to-emerald-600',
    administrativeRegion: 'Región Valles',  
    NumerodeUgas: '8',
    EcologicaZona: 'Área Natural Protegida Área Municipal de Protección Hidrológica Barranca del Río Santiago y Área de Protección de Recursos Naturales CADNR 043 Estado de Nayarit.',
  },
  {
    id: 3,
    name: 'Magdalena',
    shield: 'images/Escudo_Magdalena.gif',
    description: 'Con predominio de agricultura de temporal y ganadería menor, el municipio se encuentra en valles y lomeríos con suelos volcánicos y arroyos estacionales. Su territorio facilita la observación de flora y fauna local.',
    population: '21,781 habitantes',
    area: '293.2 km²',
    foundation: '1837',
    attractions: 'Los lomeríos semisecos y los campos de agave se integran con la Ruta de los Volcanes, ofreciendo paisajes amplios para caminatas y recorridos rurales. Su Parroquia de Santiago Apóstol y la Plaza Principal destacan dentro del entorno natural y cultural del municipio.',
    color: 'from-amber-500 to-orange-600',
    administrativeRegion: 'Región Valles',  
    NumerodeUgas: '10',
    EcologicaZona: 'Área Natural Protegida  Área de Protección de Recursos Naturales CADNR 043 Estado de Nayarit.',
  },
  {
    id: 4,
    name: 'Tequila',
    shield: 'images/Escudo_Tequila.png',
    description: 'Reconocido por la producción de agave azul y agricultura de riego, se localiza en valles con suelos volcánicos fértiles y pequeños ríos intermitentes. Su entorno permite el ecoturismo de naturaleza y cultural, así como la implementación de medidas de conservación.',
    population: '44,353 habitantes',
    area: '1,693 km km²',
    foundation: '1824',
    attractions: 'El Volcán de Tequila conforma un paisaje natural destacado, con senderos que recorren laderas de agave azul y vistas al valle. Destilerías históricas, la Plaza Principal y el Museo Nacional del Tequila dentro de la Ruta del Agave. Participación en procesos tradicionales de tequila.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Región Valles',  
    NumerodeUgas: '27',
    EcologicaZona: 'Área Natural Protegida  Área de Protección de Recursos Naturales CADNR 043 Estado de Nayarit y Área Municipal de Protección Hidrológica Barranca del Río Santiago.',
  },
  {
    id: 4,
    name: 'Teuchitlán',
    shield: 'images/Escudo_Teuchitlan.png',
    description: 'Con agricultura de riego como maíz y caña de azúcar, producción de agave y ganadería menor, el municipio se desarrolla en valles y lomeríos con suelos volcánicos y vegetación riparia. Sus áreas naturales y culturales favorecen el turismo rural y la aplicación de prácticas de manejo.',
    population: '9,647 habitantes',
    area: '219.9 km km²',
    foundation: '1825',
    attractions: 'Zona arqueológica de Guachimontones, recorridos en la presa de La Vega, Templo de San Juan Bautista, recorrido por campos de agave y haciendas cercanas; senderismo guiado, visitas culturales.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Región Valles',  
    NumerodeUgas: '8',
    EcologicaZona: 'Sitio RAMSAR Presa LA Vega y Área Natural Protegida  Área de Protección de Recursos Naturales CADNR 043 Estado de Nayarit.',
  }
];

const PaisajeAgaveroPage = () => {
  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };
   // SEO meta updates
   useEffect(() => {
     document.title = "Ordenamiento Ecológico Regional - Paisaje Agavero";
     const meta = document.querySelector('meta[name="description"]');
     if (meta) {
       meta.setAttribute('content', 'Página de Ordenamiento Ecológico Regional para la región Paisaje Agavero, con información sobre municipios, documentos, visor GIS y más.');
     }
   }, []);
  const [selectedMunicipality, setSelectedMunicipality] = useState(municipalities[0]);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('uga');
  const aboutContent = `

  <h2 class="text-2xl font-bold mb-4">Ordenamiento Ecológico Regional Paisaje Agavero</h2>

    <p>El Gobierno del Estado de Jalisco impulsa el desarrollo sustentable en la región denominada “Paisaje Agavero”, integrada por los municipios de Amatitán,El Arenal, Magdalena, Tequila y Teuchitlán. Para impulsar dicho desarrollo, el día 13 de agosto del año 2019, el Gobierno del Estado de Jalisco y los municipios firmaron un Convenio de Coordinación con el objetivo de realizar los instrumentos necesarios para ordenar el territorio de la región. Asimismo, se firmó con la Federación un Convenio Marco de Coordinación de fecha 27 de enero de 2020 y derivado del mismo un Convenio de Coordinación Específico (SEMARNAT-CONANP y SEDATU) de fecha 20 de febrero 2020. Estos convenios establecen los fundamentos para la colaboración en el proceso de elaboración de los siguientes instrumentos de ordenamiento territorial:
    </p>
    <br>
    
  `;

  const aboutLinks = [
    
    { text: 'Programa de Ordenamiento Ecológico y Territorial Regional', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Paisaje%20Agavero%2011-sep-2021.pdf' },
    { text: 'Plan Regional de Integración Urbana', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Programa%20Regional%20de%20Integraci%C3%B3n%20Urbana%20-%20Paisaje%20Agavero.pdf' },
    { text: 'Programas Municipales de Desarrollo Urbano (Ver en Inicio)', url: '/descargas/tapalpa' },

  ];

  const aboutDates = [
    { label: 'Inicio de proceso de formulación', date: '13/08/2019' },
    { label: 'Inicio de Consulta Pública', date: '11/03/2020' },
    { label: 'Fin de Consulta Pública', date: '15/06/2020' },
    { label: 'Sesión de validación', date: ' 13/04/2021' },
    { label: 'Fecha Publicación', date: '11/09/2021' },
  ];
  
  const bitacoraItems = [
    {
      title: 'FASE DE FORMULACIÓN',
      icon: FileSignature,
      color: 'from-blue-500 to-cyan-500',
      content: [
        {
          subtitle: 'Actas de Aprobación Municipal',
          items: [
            { text: 'Acta de Aprobación El Arenal', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/paisajeAgavero/actasaprobacion/Acta_Apro_El_Arenal.pdf' },
            { text: 'Acta de Aprobación Amatitán', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/paisajeAgavero/actasaprobacion/Acta_Apro_POEyTR_Amatitan.pdf' },
            { text: 'Acta de Aprobación Magdalena', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/paisajeAgavero/actasaprobacion/Acta_Apro_Magdalena.pdf' },
            { text: 'Acta de Aprobación Tequila', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/paisajeAgavero/actasaprobacion/Acta_Apro_Tequila.pdf' },
          ]
        },
        {
          subtitle: 'Dictámenes y Oficios',
          items: [
            { text: 'Dictamen de Congruencia PMDU El Arenal', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Dictamen/Dictamen_congruencia_El_Arenal.pdf' },
            { text: 'Dictamen de Congruencia PMDU Magdalena', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Dictamen/Dictamen_congruencia_Magdalena.pdf' },
            { text: 'Dictamen de Congruencia PMDU Tequila', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Dictamen/Dictamen_Congruencia_Tequila.pdf' },
            { text: 'Oficio CONANP', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Dictamen/DROPC_0582.pdf' },
            { text: 'Oficio SEDATU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Dictamen/Oficio_No_SOTA_0229_2021_SEDATU_PA.pdf' },
          ]
        },
        {
          subtitle: 'Convenios',
          items: [
            { text: 'Convenio de Coordinación Estado-Municipios "Región Paisaje Agavero"', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Convenio_Estado_Municipios_PA.pdf' },
            { text: 'Convenio Marco de Coordinación Estado – Federación', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/ConvenioMarcoEstado_Federacion.pdf' },
            { text: 'Convenio Específico de Coordinación Estado-Federación', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Convenio_Especifico_Región_PaisajeAgavero.pdf' },
          ]
        },
        {
          subtitle: 'Actas del Consejo Regional',
          items: [
            { text: 'Acta de Instalación', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Consejo/01_Acta_de_Instalacion_Consejo_Regional_PA.pdf' },
            { text: 'Acta de la primera extraordinaria 2020', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Consejo/02_ACTA_1ER_SESION_EXT_PAISAJE_A.pdf' },
            { text: 'Acta de la primera Ordinaria 2021', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Consejo/03_Acta_1er_sesion_ordinaria_CR_PA_2021.pdf' },
          ]
        }
      ]
    },
    {
      title: 'FASE DE EXPEDICIÓN',
      icon: FileSpreadsheet,
      color: 'from-emerald-500 to-green-500',
      content: [
        {
          subtitle: 'Consulta y Participación Ciudadana',
          items: [
            { text: 'PROETDUM_RA Consulta pública', url: 'https://siga.jalisco.gob.mx/ordenamiento/Archivos/PaisajeAgavero/PROETDUM_RA_Consulta_publica_.pdf' },
            { text: 'Respuestas Consulta Pública Paisaje Agavero', url: 'http://siga.jalisco.gob.mx/ordenamiento/Archivos/PaisajeAgavero/RespuestasPaisajeAgavero.pdf' },
            { text: 'Publicación Periódico del Estado Región Paisaje Agavero', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Publicación.pdf' },
          ]
        }
      ]
    },
    {
      title: 'FASE DE EJECUCIÓN',
      icon: Zap,
      color: 'from-amber-500 to-orange-500',
      content: [
        {
          subtitle: 'Seguimiento y Monitoreo',
          items: [
            { text: 'Boleta registral', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Boleta_Paisaje_Agavero.pdf' },
          ]
        }
      ]
    },
    {
      title: 'FASE DE EVALUACIÓN',
      icon: BarChart3,
      color: 'from-purple-500 to-violet-500',
      content: [
        {
          subtitle: 'Evaluaciones Programadas',
          items: [
            { text: 'Informes de Evaluación', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Evaluacion/Informes_de_Evaluacion.zip' },
          ]
        }
      ]
    }
  ];

  return (
    <div className="environmental-theme fade-in">
      
      <ModernBanner onScrollClick={handleScroll} />
      
      <section id="introduccion">
  <AboutSection 
          title="Ordenamiento Ecológico Regional Paisaje Agavero"
          content={aboutContent}
          links={aboutLinks}
          dates={aboutDates}
          phase="Ejecución"
          mainDocumentLink={{
            url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/PaisajeAgavero/Descargas/Publicaci%C3%B3n%20Peri%C3%B3dico%20Oficial%20Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Paisaje%20Agavero.pdf",
            text: "Publicación en Periódico Oficial"
          }}
        />
</section>


     
<section id="DocumentosE">
  <Descargas dataItems={Items} />
</section>

    


 <section id="municipios" className="municipalities-section py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-teal-50 to-cyan-100 dark:from-gray-900 dark:to-gray-800 min-h-screen font-sans">
      <div className="container mx-auto max-w-7xl">
        
        {/* --- Título Principal --- */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-teal-800 dark:text-teal-400 text-center mb-16 relative">
          <MapPin className="inline-block mr-3 mb-1 w-10 h-10" />
          Municipios de la Región : Paisaje Agavero
          <p className="text-lg font-normal text-gray-600 dark:text-gray-400 mt-2">
            Conoce los municipios y sus características clave.
          </p>
        </h2>
        
        {/* --- Grid de Tarjetas (Selector) --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {municipalities.map((municipality) => (
            <div 
              key={municipality.id}
              onClick={() => setSelectedMunicipality(municipality)}
              className={`
                municipality-card 
                rounded-2xl 
                overflow-hidden 
                shadow-xl 
                transition-all 
                duration-500 
                cursor-pointer 
                hover:shadow-2xl 
                hover:scale-[1.03]
                bg-white/90 dark:bg-gray-800/80
                backdrop-blur-sm
                border border-gray-100 dark:border-gray-700
                ${selectedMunicipality.id === municipality.id 
                  ? 'ring-4 ring-teal-500 scale-[1.03] shadow-teal-300/50 dark:shadow-teal-700/50' 
                  : 'hover:ring-2 hover:ring-teal-300'
                }
              `}
            >
              <div className={`h-28 ${municipality.color} flex flex-col items-center justify-center p-3 text-white font-bold`}>
                <img 
                  src={municipality.shield} 
                  alt={`Escudo de ${municipality.name}`} 
                  className="h-14 w-14 object-contain mb-1 drop-shadow-md"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/64x64/000000/ffffff?text=E"; }}
                />
              </div>
              <div className="p-4">
                <h3 className="text-xl font-extrabold text-center text-gray-900 dark:text-white">{municipality.name}</h3>
                <p className="text-xs text-center text-teal-600 dark:text-teal-400 mt-1 flex items-center justify-center">
                    Ver Detalles <ChevronRight className='w-3 h-3 ml-1'/>
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* --- Detalles del municipio seleccionado (Modern Panel) --- */}
        <div 
            key={selectedMunicipality.id} // Key para forzar la animación en cada selección
            className="municipality-details bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 md:p-12 max-w-6xl mx-auto border border-teal-200 dark:border-teal-900 animate-fade-in-up"
            style={{ '--delay': '200ms' }}
        >
          <div className="flex flex-col md:flex-row items-start gap-10">
            
            {/* Escudo y Descripción */}
            <div className="w-full md:w-1/3 flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-700 rounded-xl">
              <img 
                src={selectedMunicipality.shield} 
                alt={`Escudo de ${selectedMunicipality.name}`} 
                className="h-48 w-48 object-contain shadow-lg rounded-full p-2 bg-white dark:bg-gray-900 mb-6 border-4 border-teal-300 dark:border-teal-500"
                onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/192x192/000000/ffffff?text=E"; }}
              />
              <h3 className="text-3xl font-bold mb-2 text-gray-900 dark:text-white text-center">{selectedMunicipality.name}</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm text-center italic mt-2">{selectedMunicipality.description}</p>
            </div>
            
            {/* Información Detallada (Badges) */}
            <div className="w-full md:w-2/3">
                
                <h4 className="text-2xl font-bold text-teal-700 dark:text-teal-400 mb-6 border-b border-gray-200 dark:border-gray-700 pb-2 flex items-center">
                    <Info className='w-5 h-5 mr-2'/> Datos Clave
                </h4>

                {/* Grid de Métricas */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <DetailBadge icon={Users} label="Población" value={selectedMunicipality.population} />
                    <DetailBadge icon={Map} label="Superficie" value={selectedMunicipality.area} />
                    <DetailBadge icon={Calendar} label="Municipalización" value={selectedMunicipality.foundation} />
                    <DetailBadge icon={Landmark} label="Región Administrativa" value={selectedMunicipality.administrativeRegion} />
                    <DetailBadge icon={MapPin} label="Número de UGAs" value={selectedMunicipality.NumerodeUgas} />
                    <DetailBadge icon={MountainSnow} label="Zonas de Importancia Ecológica" value={selectedMunicipality.EcologicaZona} />
                </div>
                
                {/* Atracciones (Full Width) */}
                <div className="mt-8 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <h4 className="text-xl font-bold text-gray-900 dark:text-white mb-3 flex items-center">
                        <TreePineIcon className='text-blue-500 mr-2 w-5 h-5'/> Principales Atracciones
                    </h4>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:border-blue-800">
                        {selectedMunicipality.attractions}
                    </p>
                </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>


     {/* <section className="flex flex-col md:flex-row flex-1">
    <aside className="w-full md:w-96 bg-white shadow-2xl border-r border-gray-200 p-6 flex flex-col">
          
          <div className="mb-6">
            <img
              src="/images/Clave-de-UGA-agavero.png"
              alt="Diagrama UGAs"
              className="rounded-xl shadow-md"
            />
          </div>

     
          <div className="mb-6">
            <h2 className="text-xl font-bold text-sky-700 mb-2">
              Descripción de las UGAs
            </h2>
            <p className="text-gray-700 leading-relaxed">
              La región de Paisaje Agavero está dividida en Unidades de Gestión Ambiental
              (UGAs), definidas por criterios ecológicos, sociales y económicos.
              Cada UGA establece lineamientos de uso de suelo, conservación y
              estrategias de desarrollo sustentable.

            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-sky-700 mb-4"> Descripción de Política Ambiental:
</h2>
           <p className="text-gray-700 leading-relaxed">
            El presente Modelo de Ordenamiento Ecológico y Territorial Regional considera una zonificación, integrada por seis políticas que buscan definir el estado deseable del territorio mediante lineamientos, estrategias y criterios para conservar y controlar el deterioro del ambiente así como el aprovechamiento sustentable de los recursos naturales.


            </p>
          </div>
        </aside>
     
      </section> */}
    <FullWidthVisorWithSidebar />
     
           <ModernBitacoraSection items={bitacoraItems} />
           <FasesSection 
             imageUrl="images/FasesOrdenamiento.png"
             altText="Fases del Ordenamiento Chapala"
           />
      <section id="Bitacora">
  



</section>
      {/* <section id="Fases">
  <FasesSection 
          imageUrl="images/FasesOrdenamiento.png"
          altText="Fases del Ordenamiento Paisaje Agavero"
        />
</section> */}
     
    </div>
  );
};

export default PaisajeAgaveroPage;